import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'moduleImage',
  standalone: true,
})
export class ModuleImagePipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case 'products':
        return 'assets/images/landing/box1.png';
      case 'mechanics':
        return 'assets/images/landing/box2.png';

      case 'tips':
        return 'assets/images/landing/box3.png';

      case 'stores':
        return 'assets/images/landing/box4.png';

      case 'payments':
        return 'assets/images/landing/box5.png';

      case 'results':
        return 'assets/images/landing/box6-n.png';

      default:
        return '';
    }
  }
}
